// extracted by mini-css-extract-plugin
export default {"permission":"permission_permission"};